import { useTranslation } from "react-i18next";

export const useWithoutTemplateFilter = () => {
  const { t } = useTranslation();

  const filters = [
    {
      text: t("indicator:withoutTemplate"),
      value: "null",
    },
  ];

  return {
    filters,
  };
};
